/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* A1Build: product-card quantity sheet (opened by the price-row plus button) */
(function () {
  function closeAllQtyPanels() {
    document.querySelectorAll('[data-qty-panel].is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-qty-overlay].is-open').forEach(function (overlay) {
      overlay.classList.remove('is-open');
    });
    document.querySelectorAll('[data-qty-open][aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-qty-open]');
    if (openBtn) {
      e.preventDefault();
      var card = openBtn.closest('.product-item');
      var panel = card && card.querySelector('[data-qty-panel]');
      if (!panel) return;
      var wasOpen = panel.classList.contains('is-open');
      closeAllQtyPanels();
      if (!wasOpen) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'true');
        var overlay = card.querySelector('[data-qty-overlay]');
        if (overlay) overlay.classList.add('is-open');
        var display = panel.querySelector('[data-qty-display]');
        if (display) display.value = 1;
        var formQty = panel.querySelector('form input[name="quantity"]');
        if (formQty) formQty.value = 1;
      }
      return;
    }

    var stepBtn = e.target.closest('[data-qty-step]');
    if (stepBtn) {
      var stepPanel = stepBtn.closest('[data-qty-panel]');
      var display = stepPanel.querySelector('[data-qty-display]');
      var next = (parseInt(display.value, 10) || 1) + parseInt(stepBtn.getAttribute('data-qty-step'), 10);
      display.value = Math.max(1, next);
      var stepFormQty = stepPanel.querySelector('form input[name="quantity"]');
      if (stepFormQty) stepFormQty.value = display.value;
      return;
    }

    var atcBtn = e.target.closest('[data-qty-panel] [data-action="add-to-cart"]');
    if (atcBtn) {
      setTimeout(closeAllQtyPanels, 400);
      return;
    }

    if (e.target.closest('[data-qty-close]')) {
      closeAllQtyPanels();
      return;
    }

    if (!e.target.closest('[data-qty-panel]')) {
      closeAllQtyPanels();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllQtyPanels();
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-qty-display]')) {
      var panel = e.target.closest('[data-qty-panel]');
      var formQty = panel && panel.querySelector('form input[name="quantity"]');
      if (formQty) formQty.value = Math.max(1, parseInt(e.target.value, 10) || 1);
    }
  });

  document.addEventListener('submit', function (e) {
    if (e.target.closest('[data-qty-panel]')) {
      setTimeout(closeAllQtyPanels, 400);
    }
  }, true);
})();
